export const ENTRIES = [
    {
        name: "Rob Lantz",
        golfers: [
            "Jordan Spieth",
            "Dustin Johnson",
            "Paul Casey",
            "Justin Thomas",
            "Xander Schauffele",
        ],
        tiebreaker: -14,
    },
    {
        name: "Megan Eggert",
        golfers: [
            "Justin Thomas",
            "Jon Rahm",
            "Jordan Spieth",
            "Rory McIlroy",
            "Webb Simpson",
        ],
        tiebreaker: -11,
    },
    {
        name: "Mike Kizman 1",
        golfers: [
            "Dustin Johnson",
            "Webb Simpson",
            "Rory McIlroy",
            "Jordan Spieth",
            "Justin Thomas",
        ],
        tiebreaker: -15,
    },
    {
        name: "George Eggert",
        golfers: [
            "Collin Morikawa",
            "Jon Rahm",
            "Xander Schauffele",
            "Justin Thomas",
            "Daniel Berger",
        ],
        tiebreaker: -12,
    },
    {
        name: "Ron Fortman",
        golfers: [
            "Dustin Johnson",
            "Justin Thomas",
            "Jordan Spieth",
            "Cameron Smith",
            "Jon Rahm",
        ],
        tiebreaker: -15,
    },
    {
        name: "Bob Churchill",
        golfers: [
            "Justin Thomas",
            "Bryson DeChambeau",
            "Jon Rahm",
            "Jordan Spieth",
            "Tony Finau",
        ],
        tiebreaker: -17,
    },
    {
        name: "Brian Wade",
        golfers: [
            "Jordan Spieth",
            "Dustin Johnson",
            "Rory McIlroy",
            "Jon Rahm",
            "Sergio Garcia",
        ],
        tiebreaker: -11,
    },
    {
        name: "Marc Camardo",
        golfers: [
            "Dustin Johnson",
            "Jordan Spieth",
            "Justin Thomas",
            "Rory McIlroy",
            "Bryson DeChambeau",
        ],
        tiebreaker: -17,
    },
    {
        name: "Pete Majeski",
        golfers: [
            "Justin Thomas",
            "Rory McIlroy",
            "Xander Schauffele",
            "Sungjae Im",
            "Joaquin Niemann",
        ],
        tiebreaker: -12,
    },
    {
        name: "Ernie Cervantes",
        golfers: [
            "Jordan Spieth",
            "Sergio Garcia",
            "Dustin Johnson",
            "Cameron Smith",
            "Collin Morikawa",
        ],
        tiebreaker: -14,
    },
    {
        name: "Karl Stevens 2",
        golfers: [
            "Matt Kuchar",
            "Tony Finau",
            "Viktor Hovland",
            "Jason Day",
            "Paul Casey",
        ],
        tiebreaker: -12,
    },
    {
        name: "Jon Duppler",
        golfers: [
            "Jon Rahm",
            "Justin Thomas",
            "Dustin Johnson",
            "Corey Conners",
            "Sungjae Im",
        ],
        tiebreaker: -14,
    },
    {
        name: "Karl Stevens 1",
        golfers: [
            "Dustin Johnson",
            "Bryson DeChambeau",
            "Jordan Spieth",
            "Jon Rahm",
            "Justin Thomas",
        ],
        tiebreaker: -17,
    },
    {
        name: "E Kizman",
        golfers: [
            "Dustin Johnson",
            "Justin Thomas",
            "Jon Rahm",
            "Rory McIlroy",
            "Collin Morikawa",
        ],
        tiebreaker: -16,
    },
    {
        name: "Alan Shapiro",
        golfers: [
            "Rory McIlroy",
            "Matthew Wolff",
            "Tommy Fleetwood",
            "Dustin Johnson",
            "Justin Thomas",
        ],
        tiebreaker: -12,
    },
    {
        name: "Matt Shapiro",
        golfers: [
            "Jon Rahm",
            "Rory McIlroy",
            "Bryson DeChambeau",
            "Brooks Koepka",
            "Dustin Johnson",
        ],
        tiebreaker: -13,
    },
    {
        name: "Nick Morini",
        golfers: [
            "Dustin Johnson",
            "Justin Thomas",
            "Jordan Spieth",
            "Jon Rahm",
            "Patrick Cantlay",
        ],
        tiebreaker: -14,
    },
    {
        name: "Roger VanWazer",
        golfers: [
            "Sungjae Im",
            "Jason Day",
            "Justin Thomas",
            "Xander Schauffele",
            "Patrick Cantlay",
        ],
        tiebreaker: -6,
    },
    {
        name: "Connie Wade",
        golfers: [
            "Collin Morikawa",
            "Dustin Johnson",
            "Jordan Spieth",
            "Bryson DeChambeau",
            "Justin Thomas",
        ],
        tiebreaker: -12,
    },
    {
        name: "Tom Arndt",
        golfers: [
            "Daniel Berger",
            "Dustin Johnson",
            "Jordan Spieth",
            "Paul Casey",
            "Justin Thomas",
        ],
        tiebreaker: -12,
    },
    {
        name: "Matt Majeski",
        golfers: [
            "Tommy Fleetwood",
            "Cameron Smith",
            "Justin Thomas",
            "Jordan Spieth",
            "Dustin Johnson",
        ],
        tiebreaker: -15,
    },
    {
        name: "H Kiz",
        golfers: [
            "Jordan Spieth",
            "Dustin Johnson",
            "Justin Thomas",
            "Xander Schauffele",
            "Bryson DeChambeau",
        ],
        tiebreaker: -17,
    },
    {
        name: "Nick Pantaleos",
        golfers: [
            "Jon Rahm",
            "Justin Thomas",
            "Abraham Ancer",
            "Dustin Johnson",
            "Adam Scott",
        ],
        tiebreaker: -15,
    },
    {
        name: "Matt Seibert",
        golfers: [
            "Justin Thomas",
            "Dustin Johnson",
            "Brooks Koepka",
            "Xander Schauffele",
            "Patrick Reed",
        ],
        tiebreaker: -13,
    }
]